import React, { useState } from "react";
import * as S from "./styled";
import ResponseForm from "_c/response-form/index";
import moment from "moment";
import { Link } from "react-router-dom";
import PT from "prop-types";
import { LinkGenerator } from "@/utils/LinkGenerator";
import { Button } from "_c/button";
import { generateUrl } from "@/utils/cloudinary";

const Item = ({
  comment: data,
  isOwner,
  allowPhoto,
  onUpdate,
  onComment,
  t,
  ...props
}) => {
  const [strategy, setStrategy] = useState("response");
  const [showResponseForm, setShowResponseForm] = useState(false);
  const { author } = data;
  const onRemove = () => props.onRemove(data._id);
  const toggleResponseForm = () => setShowResponseForm((show) => !show);
  const onSubmit = async (payload) => {
    if (strategy === "response") {
      await onComment({
        ...payload,
        respondTo: data._id,
      });
    } else if (strategy === "update") {
      await onUpdate({
        ...payload,
        author: data.author._id,
        _id: data._id,
        respondTo: data.respondTo,
      });
    }
    setShowResponseForm(false);
  };
  const authorLink = author.master
    ? LinkGenerator.masterProfile(author.master)
    : LinkGenerator.clientProfile(author._id);
  const photo = data.photo && generateUrl(data.photo);
  return (
    <React.Fragment>
      <S.Wrap>
        <S.InnerWrap>
          <Link to={authorLink}>
            <S.Avatar
              size="lg"
              avatar={author.avatar}
              sex={author.sex}
              online={author.online}
            />
          </Link>
          <S.Sect>
            <Link to={authorLink}>
              <S.Name>
                {[author.first_name, author.last_name]
                  .filter(Boolean)
                  .join(" ")}
              </S.Name>
            </Link>
            <S.When>{moment(data.created_at).calendar()}</S.When>
            <S.Quote>{data.text}</S.Quote>
            {photo && (
              <S.MobileFigure>
                <a href={photo} target="_blank">
                  <S.Photo src={photo} />
                </a>
              </S.MobileFigure>
            )}
            <S.ButtonSect>
              {!isOwner && (
                <Button
                  outline
                  small
                  onClick={() => {
                    setStrategy("response");
                    toggleResponseForm();
                  }}
                >
                  {t("common:respond")}
                </Button>
              )}
              {false && isOwner && (
                <Button
                  small
                  onClick={() => {
                    setStrategy("update");
                    toggleResponseForm();
                  }}
                >
                  {t("common:change")}
                </Button>
              )}
              {isOwner && (
                <S.RemoveButton onClick={onRemove}>
                  {t("common:remove")}
                </S.RemoveButton>
              )}
            </S.ButtonSect>
          </S.Sect>
          {photo && (
            <S.Figure>
              <a href={photo} target="_blank">
                <S.Photo src={photo} />
              </a>
            </S.Figure>
          )}
        </S.InnerWrap>
      </S.Wrap>
      <ResponseForm
        onClose={() => setShowResponseForm(false)}
        t={t}
        allowPhoto={allowPhoto}
        photo={strategy === "update" ? data.photo : ""}
        text={strategy === "update" ? data.text : ""}
        isOpen={showResponseForm}
        onSubmit={onSubmit}
      />
    </React.Fragment>
  );
};
Item.propTypes = {
  comment: PT.object,
  isOwner: PT.bool,
  allowPhoto: PT.bool,

  onRemove: PT.func.isRequired,
  onComment: PT.func.isRequired,
  //onUpdate: PT.func.isRequired,
  t: PT.func.isRequired,
};

export default Item;
